<template>
    <div class="details-box">
        <div class="details-top" v-if="workorderList.length > 0">
            <Card>
                <template #title>
                    <h2>工单</h2>
                </template>
                <div class="details_top_list">
                    <div class="top_list_item" v-for="item in   workorderList  " :key="item.id">
                        <span style="margin-right: 10px;">{{ item.maintainerName }}</span>
                        <span v-if="item.state == 2">
                            <span>{{ item.addSubState == 2 ? "接单响应时间慢扣" + item.fraction + "分"
            : item.addSubState == 1 ? "接单响应时间良好加" + item.fraction + "分" : "" }}</span>
                            <template v-if="item.becauseTime">
                                <span
                                    :style="{ 'color': item.timeoutLevel == 0 ? '#4991ff' : item.timeoutLevel > 0 ? 'red' : '' }">
                                    【规则：{{ item.timeoutLevel == 0 ? "时长" : item.timeoutLevel == 1 ? "一级超时" :
            item.timeoutLevel
                == 2 ? "二级超时" : item.timeoutLevel == 3 ? "三级超时" : ""
                                    }}（{{ item.becauseTime.split(":")[0] + "时" + item.becauseTime.split(":")[1] + "分"
                                    }}）】
                                </span>
                            </template>
                            <span>{{ item.remark }}</span>
                        </span>
                        <span v-if="item.state == 3">
                            <span>{{ item.addSubState == 2 ? "工单完成时间慢扣" + item.fraction + "分"
            : item.addSubState == 1 ? "工单完成时间良好加" + item.fraction + "分" : "" }}</span>
                            <template v-if="item.becauseTime">
                                <span
                                    :style="{ 'color': item.timeoutLevel == 0 ? '#4991ff' : item.timeoutLevel > 0 ? 'red' : '' }"
                                    v-if="item.becauseTime">
                                    【规则：{{ item.timeoutLevel == 0 ? "时长" : item.timeoutLevel == 1 ? "一级超时" :
            item.timeoutLevel
                == 2 ? "二级超时" : item.timeoutLevel == 3 ? "三级超时" : ""
                                    }}（{{ item.becauseTime.split(":")[0] + "时" + item.becauseTime.split(":")[1] + "分"
                                    }}）】
                                </span>
                            </template>
                        </span>
                        <span style="margin-left: 10px;">
                            <!-- {{ dayjs(item.createTime).format("YYYY-MM-DD HH:mm:ss") }} -->
                            {{ item.createTime }}
                        </span>
                        <span style="color: #4991ff; cursor: pointer;margin-left: 10px;" @click="toInfo(item.workId)">
                            工单详情>>>>>
                        </span>
                    </div>
                </div>
            </Card>
        </div>
        <div class="details-center" v-if="ConsumablesWorkorderList.length > 0">
            <Card>
                <template #title>
                    <h2>耗材工单</h2>
                </template>
                <div class="details_center_list">
                    <div class="center_list_item" v-for="  item   in   ConsumablesWorkorderList  " :key="item.id">
                        <span style="margin-right: 10px;">{{ item.maintainerName }}</span>
                        <span v-if="item.state == 2">
                            <span>{{ item.addSubState == 2 ? "接单响应时间慢扣" + item.fraction + "分"
            : item.addSubState == 1 ? "接单响应时间良好加" + item.fraction + "分" : "" }}</span>
                            <template v-if="item.becauseTime">
                                <span
                                    :style="{ 'color': item.timeoutLevel == 0 ? '#4991ff' : item.timeoutLevel > 0 ? 'red' : '' }"
                                    v-if="item.becauseTime">
                                    【规则：{{ item.timeoutLevel == 0 ? "时长" : item.timeoutLevel == 1 ? "一级超时" :
            item.timeoutLevel
                == 2 ? "二级超时" : item.timeoutLevel == 3 ? "三级超时" : ""
                                    }}（{{ item.becauseTime.split(":")[0] + "时" + item.becauseTime.split(":")[1] + "分"
                                    }}）】
                                </span>
                            </template>
                        </span>
                        <span v-if="item.state == 3">
                            <span>{{ item.addSubState == 2 ? "工单完成时间慢扣" + item.fraction + "分"
            : item.addSubState == 1 ? "工单完成时间良好加" + item.fraction + "分" : "" }}</span>
                            <template v-if="item.becauseTime">
                                <span
                                    :style="{ 'color': item.timeoutLevel == 0 ? '#4991ff' : item.timeoutLevel > 0 ? 'red' : '' }"
                                    v-if="item.becauseTime">
                                    【规则：{{ item.timeoutLevel == 0 ? "时长" : item.timeoutLevel == 1 ? "一级超时" :
            item.timeoutLevel
                == 2 ? "二级超时" : item.timeoutLevel == 3 ? "三级超时" : ""
                                    }}（{{ item.becauseTime.split(":")[0] + "时" + item.becauseTime.split(":")[1] + "分"
                                    }}）】
                                </span>
                            </template>
                        </span>
                        <span style="margin-left: 10px;">
                            <!-- {{ dayjs(item.createTime).format("YYYY-MM-DD HH:mm:ss") }} -->
                            {{ item.createTime }}
                        </span>
                        <span style="color: #4991ff;cursor: pointer;margin-left: 10px;"
                            @click="handleEdit(item.workId)">
                            耗材详情>>>>>
                        </span>
                    </div>
                </div>
            </Card>
        </div>
        <div class="details-bottom" v-if="awardsAndPunishmentsList.length > 0">
            <Card>
                <template #title>
                    <h2>奖励与处罚</h2>
                </template>
                <div class="details_bottom_list">
                    <div class="bottom_list_item" v-for="  item   in   awardsAndPunishmentsList  " :key="item.id">
                        <span style="margin-right: 10px;">{{ item.maintainerName }}</span>
                        <span>
                            {{ item.addSubState == 2 ? item.createBy + "扣除" + item.fraction + "分"
            : item.addSubState == 1 ? item.createBy + "奖励" + item.fraction + "分" : "" }}
                          {{item.remark?`（原因：${item.remark}）`:''}}
                        </span>
                        <span style="margin-left: 10px;">
                            {{ item.createTime }}
                        </span>
                    </div>
                </div>
            </Card>
        </div>
        <div class="details-inventory" v-if="inventoryList.length > 0">
            <Card>
                <template #title>
                    <h2>每日盘点</h2>
                </template>
                <div class="details_inventory_list">
                    <div class="inventory_list_item" v-for="  item   in   inventoryList  " :key="item.id">
                        <span style="margin-right: 10px;">{{ item.maintainerName }}</span>
                        <span>
                            {{ dayjsS(item.createTime).format("YYYY-MM-DD") }}
                        </span>
                        <span style="margin-left: 10px;">
                            已盘点{{ item.timeoutLevel ? item.timeoutLevel : 0 }}个{{ item.addSubState == 1 ?
            `加${item.fraction}分` :
            `缺${item.allWorkNumber - item.timeoutLevel}个扣${item.fraction}分`
                            }}（规定{{ item.allWorkNumber }}个）
                        </span>
                    </div>
                </div>
            </Card>
        </div>
        <div class="inspection-bottom" v-if="inspectionList.length > 0">
            <Card>
                <template #title>
                    <h2>每日巡检</h2>
                </template>
                <div class="details_inspection_list">
                    <div class="inspection_list_item" v-for="  item   in   inspectionList  " :key="item.id">
                        <span style="margin-right: 10px;">{{ item.maintainerName }}</span>
                        <span>
                            {{ dayjsS(item.createTime).format("YYYY-MM-DD") }}
                        </span>
                        <span style="margin-left: 10px;">
                            已巡检{{ item.timeoutLevel?item.timeoutLevel:0 }}个{{ item.addSubState == 1 ? `加${item.fraction}分` :
                            `缺${item.allWorkNumber - item.timeoutLevel}个扣${item.fraction}分`
                            }}（规定{{item.allWorkNumber}}个）
                        </span>
                    </div>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    data() {
        return {
            id: "",
            workorderList: [],
            ConsumablesWorkorderList: [],
            awardsAndPunishmentsList: [],
            inspectionList: [],
            inventoryList: [],
            dayjsS: dayjs
        }
    },
    created() {
        let query = this.$route.query;
        this.id = query.id
        this.load()
    },
    methods: {
        async load() {
            let d = {
                fractionId: this.id
            }
            let res = await $utils.api.load("/admin/system/fraction/list", d, "get")
            console.log(res);
            let rows = res.rows
            rows.forEach(item => {
                if (item.moveBy == 1) {
                    this.workorderList.push(item)
                } else if (item.moveBy == 2) {
                    this.ConsumablesWorkorderList.push(item)
                } else if (item.moveBy == 3) {
                    this.awardsAndPunishmentsList.push(item)
                } else if (item.moveBy == 5) {
                    this.inspectionList.push(item)
                } else if (item.moveBy == 4) {
                    this.inventoryList.push(item)
                }
            });
        },
        toInfo(id) {
            $utils.url.push({
                name: "workOrder_info",
                query: { action: "edit", kv: id, workId: id },
            });
        },
        handleEdit(id) {
            $utils.url.push({ name: "recordInfo", query: { action: "edit", kv: id } });
        },
    }
}
</script>

<style lang="less" scoped>
.details-box {

    .details-top,
    .details-center,
    .details-bottom,
    .details-inventory {
        margin-bottom: 20px;
    }

    .bottom_list_item,
    .top_list_item,
    .center_list_item,
    .inventory_list_item,
    .inspection_list_item {
        margin-bottom: 10px;
    }
}
</style>